import { configureStore } from "@reduxjs/toolkit";
import dealerReducer from "./slices/dealer/DealerSlice";
import campaignDashbordReducer from "./slices/campaign/CampaignDashbord";
import templatesReducer from "./slices/campaign/TemplatesSlice";
import productReducer from "./slices/product/ProductSlice";
import deliveryReducer from "./slices/delivery/DeliverySlice";
import managersReducer from "./slices/managers/ManagersSlice";
import appsReducer from "./slices/apps/AppsSlice";
import InvoicesReducer from "./slices/invoices/InvoicesSlice";
import inventoryReducer from "./slices/inventory/InventorySlice";
import layoutReducer from "./slices/layout/LayoutSlice";
import receiptReducer from "./slices/receipt/ReceiptSlice";
import orderReducer from "./slices/order/OrderSlice";
import dispatchReducer from "./slices/dispatch/DispatchSlice";
import productionReducer from "./slices/production/ProductionSlice";
import productionDetailsReducer from "./slices/production/ProductionDetailsSlice";

export const store = configureStore({
  reducer: {
    dealer: dealerReducer,
    campaign: campaignDashbordReducer,
    templates: templatesReducer,

    product: productReducer,
    delivery: deliveryReducer,
    managers: managersReducer,
    apps: appsReducer,
    invoices: InvoicesReducer,
    inventory: inventoryReducer,
    layout: layoutReducer,

    receipt: receiptReducer,
    order: orderReducer,
    dispatch: dispatchReducer,
    production: productionReducer,
    productionDetails: productionDetailsReducer,
  },
});
